import React from "react";
// import { useState } from "react";
// import AgencyRegistrationForm from "./AgencyRegistrationForm";
// import { GridStack } from "gridstack";
import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
import DMSHeader from "../DMSHeader/DMSHeader";
import { useLocation } from 'react-router-dom';

import ExecuteSopsForm from "./ExecuteSopsForm/ExecuteSopsForm";

import ExecuteSopsTable from "./ExecuteSopsForm/ExecuteSopsTable";


import { useTranslation } from 'react-i18next';


const ExecuteSops = (props) => {
  const { t, i18n } = useTranslation();

  const location = useLocation();
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader title={t('execute_sops_formheader')}  
//  showIconsForback={true}
  />
      ),
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 14,
      id: 2,
      //haveNoBg: true,
      component: <ExecuteSopsForm  />,
    },

    // {
    //   x: 0,
    //   y: 2,
    //   width: 12,
    //   height: 7,
    //   id: 3,
    //   component: <ExecuteSopsTable  />,
    // },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 ">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default ExecuteSops;
